import axios from 'axios'
import APIConfig from '@/data/remote/APIConfig.js'

export default class LeaveFormService {
    constructor() {
        this.apis = {
            getAll: () => axios.get(APIConfig.APIURL + '/leaveForm'),
            add: (payload) => axios.post(APIConfig.APIURL + '/leaveForm', payload),
            edit: (id, payload) => axios.put(APIConfig.APIURL + `/leaveForm/${id}`, payload),
            inActivate: (id) => axios.post(APIConfig.APIURL + `/leaveForm/${id}/inactivate`),
            // delete: (id) => axios.delete(APIConfig.APIURL + `/leaveForm/${id}`),
            rejectToBeAgent: (id, payload) => axios.post(APIConfig.APIURL + `/leaveForm/${id}/rejectToBeAgent`, payload),
            rejectLeave: (id, payload) => axios.post(APIConfig.APIURL + `/leaveForm/${id}/rejectLeave`, payload),
            submit: (id) => axios.post(APIConfig.APIURL + `/leaveForm/${id}/submit`),
            sign: (id, payload) => axios.post(APIConfig.APIURL + `/leaveForm/${id}/sign`, payload),
            HRReject: (id, payload) => axios.post(APIConfig.APIURL + `/leaveForm/${id}/HRReject`, payload),
            HRSign: (id) => axios.post(APIConfig.APIURL + `/leaveForm/${id}/HRSign`),
        }
    }

    prepareData(vm) {
        return new Promise((resolve, reject) => {
            if (vm.$store.state.leaveForm.isFetched) {
                resolve(vm.$store.state.leaveForm.list)
                return
            }
            if (vm.$store.state.leaveForm.isFetching) {
                var timer = setInterval(() => {
                    if (vm.$store.state.leaveForm.isFetching) return
                    clearInterval(timer)
                    if (vm.$store.state.leaveForm.isFetched) {
                        resolve(vm.$store.state.leaveForm.list)
                    } else {
                        reject('無法取得資料，請嘗試重新整理')
                    }
                }, 500)
                return
            }
            return this.getAll(vm)
                .then(res => {
                    vm.$store.state.leaveForm.isFetched = true
                    vm.$store.state.leaveForm.isReloaded = false
                    vm.$store.state.leaveForm.list = res.data.result || []
                    return res
                })
                .then(res => {
                    vm.$store.state.leaveForm.isFetching = false
                    resolve()
                    return res
                })
                .catch(err => {
                    vm.$store.state.leaveForm.isFetching = false
                    reject(err)
                })
        })
    }

    getAll(vm) {
        return new Promise((resolve, reject) => {
            this.apis.getAll()
                .then(res => {
                    let ok = res && res.data && res.data.status === 'ok'
                    if (ok) {
                        resolve(res)
                    } else {
                        vm.$services.alertResultError(vm, res)
                        reject(res && res.data && res.data.error || '未知的API錯誤')
                    }
                    return res
                })
                .catch(err => {
                    vm.$services.alertError(vm, err)
                    reject(err)
                })
        })
    }

    add(vm, payload) {
        return new Promise((resolve, reject) => {
            this.apis.add(payload)
                .then(res => {
                    let ok = res && res.data && res.data.status === 'ok'
                    if (ok) {
                        resolve(res)
                    } else {
                        vm.$services.alertResultError(vm, res)
                        reject(res && res.data && res.data.error || '未知的API錯誤')
                    }
                    return res
                })
                .catch(err => {
                    vm.$services.alertError(vm, err)
                    reject(err)
                })
        })
    }

    edit(vm, payload) {
        return new Promise((resolve, reject) => {
            this.apis.edit(payload.ID, payload)
                .then(res => {
                    let ok = res && res.data && res.data.status === 'ok'
                    if (ok) {
                        resolve(res)
                    } else {
                        vm.$services.alertResultError(vm, res)
                        reject(res && res.data && res.data.error || '未知的API錯誤')
                    }
                    return res
                })
                .catch(err => {
                    vm.$services.alertError(vm, err)
                    reject(err)
                })
        })
    }

    inActivate(vm, id) {
        return new Promise((resolve, reject) => {
            this.apis.inActivate(id)
                .then(res => {
                    let ok = res && res.data && res.data.status === 'ok'
                    if (ok) {
                        resolve(res)
                    } else {
                        vm.$services.alertResultError(vm, res)
                        reject(res && res.data && res.data.error || '未知的API錯誤')
                    }
                    return res
                })
                .catch(err => {
                    vm.$services.alertError(vm, err)
                    reject(err)
                })
        })
    }

    delete(vm, id) {
        return new Promise((resolve, reject) => {
            this.apis.delete(id)
                .then(res => {
                    let ok = res && res.data && res.data.status === 'ok'
                    if (ok) {
                        resolve(res)
                    } else {
                        vm.$services.alertResultError(vm, res)
                        reject(res && res.data && res.data.error || '未知的API錯誤')
                    }
                    return res
                })
                .catch(err => {
                    vm.$services.alertError(vm, err)
                    reject(err)
                })
        })
    }

    rejectToBeAgent(vm, payload) {
        return new Promise((resolve, reject) => {
            this.apis.rejectToBeAgent(payload.ID, payload)
                .then(res => {
                    let ok = res && res.data && res.data.status === 'ok'
                    if (ok) {
                        resolve(res)
                    } else {
                        vm.$services.alertResultError(vm, res)
                        reject(res && res.data && res.data.error || '未知的API錯誤')
                    }
                    return res
                })
                .catch(err => {
                    vm.$services.alertError(vm, err)
                    reject(err)
                })
        })
    }

    rejectLeave(vm, payload) {
        return new Promise((resolve, reject) => {
            this.apis.rejectLeave(payload.ID, payload)
                .then(res => {
                    let ok = res && res.data && res.data.status === 'ok'
                    if (ok) {
                        resolve(res)
                    } else {
                        vm.$services.alertResultError(vm, res)
                        reject(res && res.data && res.data.error || '未知的API錯誤')
                    }
                    return res
                })
                .catch(err => {
                    vm.$services.alertError(vm, err)
                    reject(err)
                })
        })
    }

    submit(vm, id) {
        return new Promise((resolve, reject) => {
            this.apis.submit(id)
                .then(res => {
                    let ok = res && res.data && res.data.status === 'ok'
                    if (ok) {
                        resolve(res)
                    } else {
                        vm.$services.alertResultError(vm, res)
                        reject(res && res.data && res.data.error || '未知的API錯誤')
                    }
                    return res
                })
                .catch(err => {
                    vm.$services.alertError(vm, err)
                    reject(err)
                })
        })
    }

    sign(vm, id, hours) {
        return new Promise((resolve, reject) => {
            this.apis.sign(id, {'Hours': hours})
                .then(res => {
                    let ok = res && res.data && res.data.status === 'ok'
                    if (ok) {
                        resolve(res)
                    } else {
                        vm.$services.alertResultError(vm, res)
                        reject(res && res.data && res.data.error || '未知的API錯誤')
                    }
                    return res
                })
                .catch(err => {
                    vm.$services.alertError(vm, err)
                    reject(err)
                })
        })
    }

    HRReject(vm, payload) {
        return new Promise((resolve, reject) => {
            this.apis.HRReject(payload.ID, payload)
                .then(res => {
                    let ok = res && res.data && res.data.status === 'ok'
                    if (ok) {
                        resolve(res)
                    } else {
                        vm.$services.alertResultError(vm, res)
                        reject(res && res.data && res.data.error || '未知的API錯誤')
                    }
                    return res
                })
                .catch(err => {
                    vm.$services.alertError(vm, err)
                    reject(err)
                })
        })
    }

    HRSign(vm, id) {
        return new Promise((resolve, reject) => {
            this.apis.HRSign(id)
                .then(res => {
                    let ok = res && res.data && res.data.status === 'ok'
                    if (ok) {
                        resolve(res)
                    } else {
                        vm.$services.alertResultError(vm, res)
                        reject(res && res.data && res.data.error || '未知的API錯誤')
                    }
                    return res
                })
                .catch(err => {
                    vm.$services.alertError(vm, err)
                    reject(err)
                })
        })
    }
}
